import { ReactNode } from 'react';

import { UseMarkerEditLockResult } from 'features/geoEvents/hooks/useMarkerEditLock';
import {
  IconFootprint,
  MarkerEditConnectorLine,
} from 'features/mapping/components/MarkerEditConnectorLine';
import { LatLng } from 'shared/types';

type MarkerEditGhostProps = {
  markerLock: UseMarkerEditLockResult;
  original: LatLng;
  footprint: IconFootprint;
  children: ReactNode;
};

// Shows the ghost icon (where it was) via `children` and draws a line from there to the current location
export const MarkerEditGhost = (
  props: MarkerEditGhostProps,
): JSX.Element | null => {
  const { markerLock, original, footprint, children } = props;

  if (!markerLock.stagedLatLng) return null;

  return (
    <>
      {children}
      <MarkerEditConnectorLine
        fromLatLng={{ lat: original.lat, lng: original.lng }}
        toLatLng={markerLock.stagedLatLng}
        footprint={footprint}
      />
    </>
  );
};
